export default __webpack_public_path__ + "static/media/gallery_00.525ef2da.jpg";